/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.31",
    versionName: "0.8.0-nightly.2026.10.31",
    versionChannel: "nightly",
    buildDate: "2026-10-31T00:10:44.175Z",
    commitHash: "74bb75176ec215a0242f1b75f931a74ca90be17c",
};
